import { render, staticRenderFns } from "./CardAirline.vue?vue&type=template&id=11bee298&"
import script from "./CardAirline.vue?vue&type=script&lang=js&"
export * from "./CardAirline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports